<template>
  <div class="ll-diagram-card" :class="{ 'space-between': _spaceBetween }">
    <p class="ll-diagram-card__title">
      {{ cardTitle }}
    </p>
    <div class="ll-diagram-card__btn-wrap" @click="$_btnClick(path)">
      <i v-if="buttonIcon" class="ll-diagram-card__btn" :class="buttonIcon" />
      <img v-if="buttonImg" :src="buttonImg" alt="" class="ll-diagram-card__btn image" />
    </div>
    <div v-if="tabs.length > 0" class="ll-diagram-card__tab-bar">
      <LvContentTabBar001
        wide
        :content-width="0"
        :selected-tab-id="tabValue"
        :content-tabs="tabs"
        :isLoading="isLoading"
        @click="$_contentTabOnclick($event)"
      />
    </div>
    <div v-if="customDropdowns.length > 0" class="ll-diagram-card__dropdown">
      <LlState
        v-for="(dropdownItem, dropdownKey) in customDropdowns"
        :key="dropdownKey"
        :value="dropdownItem.selectedTabId"
        is-outline
        disableCancel
        type="dropdown"
        :dropdown-menu-items="dropdownItem.dropdownSelectItems"
        :placeholder="dropdownItem.dropdownPlaceholder"
        :isDisabled="isLoading"
        :title="dropdownItem.title"
        @input="$_customDropdownsOnChange({ dropdownId: $event, dropdownKey })"
      />
    </div>
    <div v-if="dropdownMenu.length > 0" class="ll-diagram-card__dropdown">
      <LvDropdownTreeSelect
        :value="dropdownValue"
        title="領域"
        outline
        showAllOption
        :menu="dropdownMenu"
        :placeholder="dropdownPlaceholder || '請選擇'"
        :disabled="isLoading"
        @input="$_dropdownOnChange"
      />
    </div>
    <DotLoading v-if="isLoading" />
    <div v-else class="ll-diagram-card__content">
      <DiagramBarChart
        v-if="type === 'bar-chart'"
        ref="DiagramBarChart"
        :title="title"
        :y-max="yMax"
        :y-title="yTitle"
        :status-items="statusItems"
        :line-len="lineLen"
        :bottom-labels="bottomLabels"
        :events-list="eventsList"
        :tooltips="_tooltips"
        :padding-left="paddingLeft"
        :switch-btn-title="switchBtnTitle"
        :frequency-unit="frequencyUnit"
        :has-selected="hasSelected"
        @pre-click="$_switchSecPreClick($event)"
        @next-click="$_switchSecNextClick($event)"
      />
      <DiagramLineChart
        v-if="type === 'line-chart'"
        :title="title"
        :y-max="yMax"
        :y-title="yTitle"
        :status-items="statusItems"
        :line-len="lineLen"
        :bottom-labels="bottomLabels"
        :events-list="eventsList"
        :tooltips="_tooltips"
        :padding-left="paddingLeft"
        :switch-btn-title="switchBtnTitle"
        :has-dot="hasDot"
        :frequency-unit="frequencyUnit"
        :smooth-size="smoothSize"
        @pre-click="$_switchSecPreClick($event)"
        @next-click="$_switchSecNextClick($event)"
      />
      <DiagramBubbleChart
        v-if="type === 'bubble-chart'"
        :title="title"
        :y-max="yMax"
        :y-title="yTitle"
        :status-items="statusItems"
        :line-len="lineLen"
        :bottom-labels="bottomLabels"
        :events-list="eventsList"
        :tooltips="_tooltips"
        :padding-left="paddingLeft"
        :bubble-max-size="bubbleMaxSize"
        :bubble-min-size="bubbleMinSize"
        :switch-btn-title="switchBtnTitle"
        :frequency-unit="frequencyUnit"
        @pre-click="$_switchSecPreClick($event)"
        @next-click="$_switchSecNextClick($event)"
      />
    </div>
    <div v-if="isDisabled" class="ll-diagram-card__disabled">
      <i class="ll-diagram-card__disabled-icon" :class="disabledIcon" />
      <div class="ll-diagram-card__disabled-text">
        {{ disabledText }}
      </div>
      <div class="ll-diagram-card__disabled-btn">
        <WsButton001 width-stretch @click="$_disableClick()">
          {{ disabledBtnText }}
        </WsButton001>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LlDiagramCard',
  props: {
    path: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    disabledIcon: {
      type: String,
      default: 'icon-lock',
    },
    disabledText: {
      type: String,
      default: '',
    },
    disabledBtnText: {
      type: String,
      default: '',
    },
    cardTitle: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    buttonIcon: {
      type: String,
      default: 'icon-arrow-go',
    },
    buttonImg: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'bar-chart',
    },
    yTitle: {
      type: String,
      default: '',
    },
    statusItems: {
      type: Array,
      default() {
        return [];
      },
    },
    yMax: {
      type: Number,
      default: 0,
    },
    lineLen: {
      type: Number,
      default: 0,
    },
    bottomLabels: {
      type: Array,
      default() {
        return [];
      },
    },
    eventsList: {
      type: Object,
      default() {
        return {};
      },
    },
    tooltips: {
      type: Object,
      default() {
        return {};
      },
    },
    paddingLeft: {
      type: Number,
      default: 0,
    },
    bubbleMaxSize: {
      type: Number,
      default: 0,
    },
    bubbleMinSize: {
      type: Number,
      default: 0,
    },
    switchBtnTitle: {
      type: String,
      default: '',
    },
    dropdownValue: {
      type: [String, Number],
      default: 'all',
    },
    dropdownPlaceholder: {
      type: String,
      default: '',
    },
    dropdownMenu: {
      type: Array,
      default() {
        return [];
      },
    },
    tabValue: {
      type: String,
      default: '',
    },
    tabs: {
      type: Array,
      default() {
        return [];
      },
    },
    hasDot: {
      type: Boolean,
      default: false,
    },
    frequencyUnit: {
      type: String,
      default: '',
    },
    smoothSize: {
      type: Number,
      default: 0,
    },
    hasSelected: {
      type: Boolean,
      default: false,
    },
    customDropdowns: {
      type: Array,
      default() {
        return [];
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contentTabs: {
        selectedTabId: '1',
        tabs: [
          {
            id: '1',
            textLabel: this.$t('綜合'),
            link: 'all',
          },
        ],
      },
    };
  },
  computed: {
    _spaceBetween() {
      return this.tabs.length === 0 && this.dropdownMenu.length === 0 ? true : false;
    },
    _tooltips() {
      const tooltips = {};
      for (let event in this.eventsList) {
        tooltips[event] = [];
        for (let item in this.eventsList[event]) {
          let itemType = this.statusItems.find(status => status.type === item);
          let tooltipItem = {};
          if (item !== 'all') {
            tooltipItem = {
              label: itemType ? itemType.color : null,
              title: itemType ? itemType.text : null,
              content: this.eventsList[event][item],
            };
            tooltips[event].push(tooltipItem);
          } else {
            tooltipItem = {
              label: this.statusItems[0].color,
              title: '全部',
              content: this.eventsList[event].all,
            };
            tooltips[event].unshift(tooltipItem);
          }
        }
      }
      return tooltips;
    },
  },
  methods: {
    $_btnClick(path) {
      if (this.isLoading) return;
      this.$emit('btn-click', path);
    },
    $_contentTabOnclick(tab) {
      if (this.isLoading) return;
      this.$emit('tab-click', tab);
    },
    $_setIntTabs() {
      if (this.tabs.length === 0) return;
      this.contentTabs.selectedTabId = this.tabs[0].id;
    },
    $_dropdownClick(payload) {
      this.$emit('dropdown-click', payload);
    },
    $_dropdownOnChange($event) {
      if (this.isLoading) return;
      if (this.dropdownValue === $event) return;
      if ($event && this.hasSelected && this.$refs.DiagramBarChart) {
        let statusItem;
        if ($event === 'all') {
          statusItem = this.statusItems.find(item => item.type === 'all');
        } else {
          statusItem = this.statusItems.find(item => item.value === $event);
        }
        if (statusItem) {
          this.$refs.DiagramBarChart.$_statusOnChange([statusItem.value]);
        }
      }
      this.$_dropdownClick({ selectDropdown: { id: $event }, isCustomDropdownClicked: false });
    },
    $_customDropdownsOnChange({ dropdownId, dropdownKey }) {
      if (this.isLoading) return;
      if (this.dropdownValue && this.dropdownValue === dropdownId) return;
      let selectDropdown = this.customDropdowns[dropdownKey].dropdownSelectItems.find(
        item => item.id === dropdownId,
      );
      this.$_dropdownClick({ selectDropdown, isCustomDropdownClicked: true, dropdownKey });
    },
    $_switchSecPreClick($event) {
      this.$emit('pre-click', $event);
    },
    $_switchSecNextClick($event) {
      this.$emit('next-click', $event);
    },
    $_disableClick($event) {
      if (this.isLoading) return;
      this.$emit('disable-click', $event);
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/ll-diagram-card';
</style>
